import { useScope } from "hooks/useScope";
import { useTranslation } from "react-i18next";
import { FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";
import { API_URL } from "reduxFiles/api/baseApi";
import { useAppSelector } from "reduxFiles/hooks";
import packageInfo from "../../../../package.json";

const FreeCard = () => {
  const { t } = useTranslation();
  const scope = useScope();
  const user = useAppSelector((state) => state.auth.user);
  const appVersion = packageInfo.version;

  return (
    <div className="relative mt-14 flex w-[256px] justify-center rounded-[20px] bg-gradient-to-br from-[#868CFF] via-[#432CF3] to-brand-500 pb-4">
      <div className="absolute -top-12 flex h-24 w-24 items-center justify-center rounded-full border-[4px] border-white bg-gradient-to-b from-[#868CFF] to-brand-500 dark:!border-navy-800">
        {user.avatar ? (
          <img
            src={`${API_URL}/file/${user?.avatar}`}
            alt={user?.fullname || "avatarUser"}
            className="h-20 w-20 rounded-full"
          />
        ) : (
          <FiUser className="h-20 w-20 rounded-full text-white" />
        )}
      </div>

      <div className="mt-16 flex h-fit flex-col items-center gap-1">
        <p className="text-md font-bold text-white">
          {t(`user.fullname`)} : {user.fullname || "-"}
        </p>
        {user.organization && (
          <p className="text-sm font-bold text-white">
            {t(`organization.name`)} : {user.organization?.name}
          </p>
        )}
        <p className="text-sm font-bold text-white">
          {t(`user.role`)} : {t(`user.roles.${user.role}`)}
        </p>

        {scope === "user" && (
          <Link
            target="blank"
            to={"/assessment"}
            className="text-medium mt-3 block rounded-full bg-gradient-to-b from-white/50 to-white/10 px-5 py-3 text-center text-xs text-white hover:bg-gradient-to-b hover:from-white/40 hover:to-white/5 "
          >
            {t("auth.signIn.loginResponder")}
          </Link>
        )}

        {/* Version */}
        <p className="mt-1 text-xs font-medium text-white/80">
          version: {appVersion}
        </p>
      </div>
    </div>
  );
};

export default FreeCard;
